module.exports = __webpack_public_path__ + "img/ic-hannah-selamat-bergabung.f2f67c69.svg";